module.exports = __webpack_public_path__ + "img/logo.f83ac6ea.svg";